import React, { useState } from "react";
import "./CategoryCard.css";
import { FaHeart, FaEye,FaRupeeSign,FaShareAlt} from "react-icons/fa";
import { Tooltip, OverlayTrigger, Card, Badge } from "react-bootstrap";
import { getImageUrl, handleCheckUserLogin } from "../../../MIS/Global";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserLoginModal, setUserWishList } from "../../../API/Reducer/userReducer";
import useToast from "../../../API/GlobalHooks/useToast";
import { useMutation } from "@tanstack/react-query";
import { wishlistProduct_addItem, wishlistProduct_deleteItem } from "../../../API/Service/userWishlistService";
import { useWishlistQuery } from "../../../API/Model/useWishlistModel";
import { useEffect } from "react";

const CategoryCard = ({ product, 
  wishlist = false, quickView = false,path,
  price=false,productDetail=false,isShare=false
}) => {

  const navigate=useNavigate();
  const dispatch=useDispatch();
  const showToast = useToast();
  
  const [aspectRatio, setAspectRatio] = useState("1 / 1");

  const filterData={
   loginid:handleCheckUserLogin("userData","id"),
   prod_type:0,
  }
  const { userWishList } = useSelector((state) => state.user);
  const { refetch: refetchWishlistProducts } = useWishlistQuery(filterData);
  const renderTooltip = (props, title = "Simple Tooltip") => (
    <Tooltip id="button-tooltip" {...props}>
      {title}
    </Tooltip>
  );
  const handleGetWishlist = async(values) => {    
    try {
      const response = await refetchWishlistProducts();
      dispatch(setUserWishList(response?.data))      
    } catch (error) {
      
    } finally {
       
    }
  };
  const wishlistMutation = useMutation({
    mutationFn: wishlistProduct_addItem,
    onMutate: () => {      
      
    },
    onSuccess: async (resData) => {                 
      if(resData?.code==200 && Object.keys(resData?.data).length>0){                        
        showToast("Added to wishlist! ❤️", 'success');                            
        handleGetWishlist()
      }else if(resData?.code==200 && resData?.data==-1){        
        showToast("Invalid credentials! Please try again", 'danger');        
      }
      else{                
        showToast("something went wrong; Please try again!", 'danger');       
      }        
    },
    onError: (error) => {            
      showToast("Some thing went wrong; \nPlease contact your administrator!", 'danger');     
    },
    onSettled: () => {
      
    },
  });

  const deleteMutation = useMutation({
    mutationFn: wishlistProduct_deleteItem,
    onSuccess: () => {
      handleGetWishlist()
    },
    onError: (error) => {    
      showToast("Failed to wishlist transaction; please try again.", 'danger');       
    },    
  });
  const handleWishlist=(e,pid)=>{
    e.stopPropagation()
    let isLogin=handleCheckUserLogin("userData","id");
    if(isLogin<=0){
      dispatch(setUserLoginModal())
    }else{
      let isExist=false;
      let filteredById=[];
      if(userWishList.length>0
        ){          
          filteredById = userWishList.filter(item => item.pid === pid);
          if(filteredById.length>0){
            isExist=true;
          }else{isExist=false;}
        }
    if(isExist===false){
      const data = { pid: pid, loginid: isLogin, prod_type: 0 };
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        formData.append(key, data[key]);
      });
      
      wishlistMutation.mutate(data);
    }else{
      let id=filteredById?.[0]?.id;
      deleteMutation.mutate({id:id});
    }            
    }
    
  }
  const getExtension = (mimeType) => {
    switch (mimeType) {
      case 'image/jpeg': return 'jpg';
      case 'image/png': return 'png';
      case 'image/gif': return 'gif';
      default: return 'jpg'; // Default fallback
    }
  };
  const handleShare = async () => {
    try {
      // alert(`https://teeblanka.com${path}`)
      if (!navigator.canShare) {
        alert("Sharing is not supported in your browser.");
        return;
      }
  
      // Fetch image
      const response = await fetch(getImageUrl(`/media/${product?.imgpath}`));
      const blob = await response.blob();
      const ext = getExtension(blob.type);
      const file = new File([blob], `product.${ext}`, { type: blob.type });
  
      // Check if files can be shared
      if (navigator.canShare({ files: [file] })) {
        await navigator.share({
          files: [file], // Attach image file
          title: "Awesome Product-1",
          text: `Check out this products!`, // Text description + URL
          url:`https://teeblanka.com${path}`,
        });
      } else {
        alert("Your device does not support file sharing.");
      }
    } catch (error) {
      // console.error("Error sharing:", error);
      // alert("Error sharing content.");
    }
  };
  // useEffect(() => {
  //   const img = new Image();
  //   img.src = getImageUrl(`/media/${product?.imgpath}`);
  //   img.onload = () => {
  //     setIsPortrait(img.naturalHeight > img.naturalWidth);
  //   };
  // }, [product]);
  const handleImageLoad = (event) => {
    const { naturalWidth, naturalHeight } = event.target;
    setAspectRatio(`${naturalWidth} / ${naturalHeight}`);
  };
  return (
    <>
      <div className="card product-card shadow-sm" 
      onClick={()=>{         
        navigate(path);        
      }}>
      <div className="card-img-container" style={{ aspectRatio }}>
        <img
          src={getImageUrl(`/media/${product?.imgpath}`)}
          alt={product?.id}
          className="card-img-top"
          onLoad={handleImageLoad} 
          // className={`card-img-top ${isPortrait ? "portrait" : "landscape"}`}

        />
        {/* Wishlist and Quick View Buttons */}
        {isShare && (
        <button            
            type="button"
            onClick={(e)=>{
              e.stopPropagation();
              handleShare()
            }}
            className={`
             btn p-0 border-0 bg-transparent d-block d-md-none
             share-button
            `}
          >
            <FaShareAlt size={18}/>
        </button>
        )}
      </div>
      <div className={`p-1 ${productDetail?"":"d-none"}`}
       style={{marginTop:'-08px'}}
      >
        <span className="text-truncate"
        style={{width:'100%',fontWeight:600,fontSize:"0.7rem"}}
        >
        {product?.productname
          ?.toLowerCase()
          .split(" ")
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ")}
        </span>
        <div className={`d-flex justify-content-between align-items-center ${price?"":"d-none"}`}>
          <div>                     
          <Badge
            style={{
              fontSize: "0.7rem",
              padding: "3px 3px",              
              color: "white",
              borderRadius: "5px",
              
            }}
            className='bg-danger'
          >
            <FaRupeeSign/>{product?.min_mrp}
          </Badge>
          &nbsp;|&nbsp;
          <span
           style={{fontWeight:600,fontSize:"0.7rem"}}
          >{product?.productcode}</span>
          </div>
          <div className={`${product?.isWishlist===true?"action-buttons_fixed":"action-buttons"} `}>
          <OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            title="Add to Wishlist"
            overlay={(props) => renderTooltip(props, "Add to Wishlist")}
          >
            <div onClick={(e)=>{handleWishlist(e,product?.id)}}
              className={`action-button ${product?.isWishlist===true?"action-button_active":""}
              ${wishlist ? "" : "d-none"}`}>
              <FaHeart />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="left"
            delay={{ show: 250, hide: 400 }}
            title="Add to Wishlist"
            overlay={(props) => renderTooltip(props, "Quick View")}
          >
            <div className={`action-button ${quickView ? "" : "d-none"}`}>
              <FaEye />
            </div>
          </OverlayTrigger>
          </div>
        </div>
      </div>
    </div>
    </>
    
  );
};

export default CategoryCard;
